export const UPDATE_NODE = "UPDATE_NODE";
export const SET_INTEGRATION = "SET_INTEGRATION";
export const UPDATE_TRANSACTION = "UPDATE_TRANSACTION";
